export const getFileNameAndType = (text) => {
    const arr = text.split('.');
    return [arr.pop(), arr.join('.')];
};
